/*
* Product Image ScrollTo Interaction
*
**/

custom.pdpCustomContents = (function() {

	const className = "js-pdp-custom-contents";
	const activeClassName = "active";

	function wrapperHandler() {
		if (!$(`.${className}`)) return;
		const $section = $(`.${className}`);
		const NumOfVisble = $(`.${className} > *:visible`).length;
		(NumOfVisble > 0) ? $section.addClass(activeClassName) : $section.removeClass(activeClassName);
	}

	function init() {
		wrapperHandler();
		$(window).on('resize', custom.utils.debounce(wrapperHandler, 600));
	}

	return {
		init
	}

})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/pdp-custom-contents.js